import ConsoleWorkspace from '@/workspaces/console/ConsoleWorkspace.vue'
import NftWorkspace from '@/workspaces/nft/NftWorkspace.vue'
import PluginDirectoryWorkspace from '@/workspaces/plugins/PluginDirectoryWorkspace.vue'
import PluginWorkspace from '@/workspaces/plugins/PluginWorkspace.vue'

export const BUILTIN_WORKSPACES = [
  {
    id: 'console',
    kind: 'builtin',
    role: 'presentation',
    label: 'Console',
    component: ConsoleWorkspace,
    default: true,
  },
  {
    id: 'nft',
    kind: 'builtin',
    role: 'page',
    label: 'NFT',
    component: NftWorkspace,
  },
  {
    id: 'plugins',
    kind: 'builtin',
    role: 'page',
    label: 'Plugins',
    component: PluginDirectoryWorkspace,
  },
]

export function pluginWorkspaces(installations = []) {
  const rows = Array.isArray(installations) ? installations.filter(Boolean) : []
  return rows
    .filter(item => item && item.enabled !== false)
    .map(item => ({
      id: `plugin:${String(item.id || '').trim()}`,
      kind: 'extension',
      role: 'presentation',
      label: String(item.plugin?.name || item.name || item.plugin_name || item.slug || 'Extension').trim() || 'Extension',
      component: PluginWorkspace,
      installation: item,
    }))
    .filter(item => item.id !== 'plugin:')
}

export function activePluginWorkspaces(installations = []) {
  return pluginWorkspaces(installations).filter(item => item.installation?.active === true)
}

export function allWorkspaces(installations = []) {
  return [...BUILTIN_WORKSPACES, ...activePluginWorkspaces(installations)]
}

export function fallbackWorkspace() {
  return BUILTIN_WORKSPACES.find(item => item.default) || BUILTIN_WORKSPACES[0]
}
